// columns.ts — the class-summary table column model.
//
// Mirrors options/tables/table_class_summary_inc.php: the thead is `level`, then `spell_known`, then one
// column per AbilityType::getAll() (includes/additions.php ~7701). Kept hardcoded + in authoring order so
// the TS table matches the PHP column order byte-for-byte. curse_known + spell_known layers both feed the
// single 'spell_known' column (the PHP buckets curse_known under item_type 'spell_known').

import type { AbilityRow } from './types';

/** AbilityType::LIST — one table column each, in PHP order. */
export const ABILITY_TYPE_COLUMNS: readonly string[] = [
    'passive_ability',
    'full_ability',
    'ability',
    'quick_ability',
    'attack_ability',
    'free_ability',
    'reaction_ability',
    'opportunity_attack_ability',
    'curse',
    'menta',
    'sanguine',
    'ability_choice',
];

export const SPELL_KNOWN_COLUMN = 'spell_known';

/** Layers that fold into the single Spell Known column (matches the PHP). */
export const SPELL_KNOWN_LAYERS: readonly string[] = ['spell_known', 'curse_known'];

/** Full column order, left→right: Spell Known first, then the AbilityType columns. */
export const ALL_COLUMNS: readonly string[] = [SPELL_KNOWN_COLUMN, ...ABILITY_TYPE_COLUMNS];

/**
 * Empty-column removal: the subset of ALL_COLUMNS that has >=1 row across the CURRENT class+subclass.
 * Returned in ALL_COLUMNS order. The Level column is always present and is not part of this set.
 */
export function computeNonEmptyColumns(rows: readonly AbilityRow[]): string[] {
    const present = new Set<string>();
    for (const r of rows) present.add(r.column);
    return ALL_COLUMNS.filter(c => present.has(c));
}
